import React, {PropTypes} from 'react';
import {
	Row,
	Col,
	FormGroup,
	FormControl,
	ControlLabel,
	Well
} from 'react-bootstrap';

import moment from 'moment';
import DatePicker from 'react-datepicker';

import DropDownMenu from './DropDownMenu';
import RequiredMark from './RequiredMark';


export const optsHour = [
				{value: '00', label: '00'}, {value: '01', label: '01'}, {value: '02', label: '02'}, {value: '03', label: '03'}, {value: '04', label: '04'}, {value: '05', label: '05'}, 
				{value: '06', label: '06'}, {value: '07', label: '07'}, {value: '08', label: '08'}, {value: '09', label: '09'}, {value: '10', label: '10'}, 
				{value: '11', label: '11'}, {value: '12', label: '12'}, {value: '13', label: '13'}, {value: '14', label: '14'}, {value: '15', label: '15'}, 
				{value: '16', label: '16'}, {value: '17', label: '17'}, {value: '18', label: '18'}, {value: '19', label: '19'}, {value: '20', label: '20'}, 
				{value: '21', label: '21'}, {value: '22', label: '22'}, {value: '23', label: '23'} 
			],
			optsMinute5 = [
				{value: '00', label: '00'}, {value: '05', label: '05'}, {value: '10', label: '10'}, {value: '15', label: '15'}, {value: '20', label: '20'}, 
				{value: '25', label: '25'}, {value: '30', label: '30'}, {value: '35', label: '35'}, {value: '40', label: '40'}, {value: '45', label: '45'}, 
				{value: '50', label: '50'}, {value: '55', label: '55'}
			],
			optsMinute1 =[
				{value: '00', label: '00'}, {value: '01', label: '01'}, {value: '02', label: '02'}, {value: '03', label: '03'}, {value: '04', label: '04'}, {value: '05', label: '05'}, 
				{value: '06', label: '06'}, {value: '07', label: '07'}, {value: '08', label: '08'}, {value: '09', label: '09'}, {value: '10', label: '10'}, 
				{value: '11', label: '11'}, {value: '12', label: '12'}, {value: '13', label: '13'}, {value: '14', label: '14'}, {value: '15', label: '15'}, 
				{value: '16', label: '16'}, {value: '17', label: '17'}, {value: '18', label: '18'}, {value: '19', label: '19'}, {value: '20', label: '20'}, 
				{value: '21', label: '21'}, {value: '22', label: '22'}, {value: '23', label: '23'}, {value: '24', label: '24'}, {value: '25', label: '25'}, 
				{value: '26', label: '26'}, {value: '27', label: '27'}, {value: '28', label: '28'}, {value: '29', label: '29'}, {value: '30', label: '30'},
				{value: '31', label: '31'}, {value: '32', label: '32'}, {value: '33', label: '33'}, {value: '34', label: '34'}, {value: '35', label: '35'}, 
				{value: '36', label: '36'}, {value: '37', label: '37'}, {value: '38', label: '38'}, {value: '39', label: '39'}, {value: '40', label: '40'}, 
				{value: '41', label: '41'}, {value: '42', label: '42'}, {value: '43', label: '43'}, {value: '44', label: '44'}, {value: '45', label: '45'}, 
				{value: '46', label: '46'}, {value: '47', label: '47'}, {value: '48', label: '48'}, {value: '49', label: '49'}, {value: '50', label: '50'}, 
				{value: '51', label: '51'}, {value: '52', label: '52'}, {value: '53', label: '53'}, {value: '54', label: '54'}, {value: '55', label: '55'}, 
				{value: '56', label: '56'}, {value: '57', label: '57'}, {value: '58', label: '58'}, {value: '59', label: '59'}
			];

export function dateFormatter(dayObj, hourStr, mmStr) {
	return moment(`${dayObj.format("YYYY-MM-DD")} ${hourStr}:${mmStr}`).format("YYYY-MM-DD HH:mm");
}			

export function dateDivider(dateString) {
	if (dateString) {
		const date = moment(dateString);

		return {
			day: date, 
			hour: date.format('HH'), 
			minute: date.format('mm') 
		};
	} else {
		return {
			day: null,
			hour: '',
			minute: ''
		}
	}
}

const FullDatePicker = props => {

	const onChange = (selection, stateName) => {
		const dateStateNames = {
			dayStateName: props.dayStateName,
			hourStateName: props.hourStateName,
			minuteStateName: props.minuteStateName
		};

		const dateStateValues = {
			dayStateValue: props.dayValue,
			hourStateValue: props.hourValue,
			minuteStateValue: props.minuteValue
		};

		props.onChange(selection, stateName, dateStateNames, dateStateValues);
	};

	return (
		<div>
	    <Col sm={12}>
	      <div style={{fontWeight: "bold", marginBottom: 5}}>{props.showRequiredMark && <RequiredMark />}{props.outerLabel}</div>
	    </Col>

	    <Col sm={12}>
	      <Well style={{marginBottom: 15, paddingBottom: 24}}>
	        <Row>
	          <Col sm={4}>
	            <FormGroup controlId="fromDay">
	              <ControlLabel>日</ControlLabel>
	              <FormControl componentClass="div" style={{height: 36}}>
	                <DatePicker
	                  disabled={props.disabled}
	                  placeholderText="Pick a date here"
	                  className="work-log-day-picker"
	                  dateFormat="YYYY/MM/DD"
	                  onChange={(date) => {
	                  	onChange(date, props.dayStateName);
	                  }}
	                  selected={props.dayValue} />
	              </FormControl>
	            </FormGroup>
	          </Col>

	          <DropDownMenu
	            sm={4}
	            disabled={props.disabled}
	            label="時"
	            stateName={props.hourStateName}
	            value={props.hourValue}
	            onChange={onChange}
	            options={props.optsHour}
	             />

	          <DropDownMenu
	            sm={4}
	            disabled={props.disabled}
	            label="分"
	            value={props.minuteValue}
	            stateName={props.minuteStateName}
	            onChange={onChange}
	            options={props.optsMinute}
	             />

	        </Row>
	      </Well>
	    </Col>
	  </div>
  );
};

FullDatePicker.defaultProps = {
	outerLabel: '時間',
	optsHour: optsHour,
	optsMinute: optsMinute5
};

FullDatePicker.propTypes = {
	disabled: PropTypes.any, 
	outerLabel: PropTypes.string, 
	showRequiredMark: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	dayStateName: PropTypes.string.isRequired, 
	dayValue: PropTypes.any, // 不限定為obj原因為無值時需設定為null
	hourStateName: PropTypes.string.isRequired, 
	hourValue: PropTypes.string.isRequired, 
	minuteStateName: PropTypes.string.isRequired,
	minuteValue: PropTypes.string.isRequired,
	optsHour: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)), 
	optsMinute: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string))
};

export default FullDatePicker;


// WEBPACK FOOTER //
// ./src/commonComponents/FullDatePicker.jsx